import * as React from 'react';

import { cn } from 'DesignSystem/utils';

import { useItemSidebarRouteState } from '../item-sidebar-route-state';
import CardSideBar from './card';
import { SelectedItem } from './item';

export default function CardDetailSidebar() {
  const { selectedItemId: itemId } = useItemSidebarRouteState();
  const [isOpen, setIsOpen] = React.useState(Boolean(itemId));
  const [persistedItemId, setPersistedItemId] = React.useState(itemId);

  React.useEffect(() => {
    if (itemId) {
      setPersistedItemId(itemId);
      const timeout = setTimeout(() => {
        setIsOpen(true);
      }, 100);
      return () => {
        if (timeout) clearTimeout(timeout);
      };
    } else {
      setIsOpen(false);
      const timeout = setTimeout(() => {
        setPersistedItemId(null);
      }, 300);
      return () => {
        if (timeout) clearTimeout(timeout);
      };
    }
  }, [itemId]);

  return (
    <>
      <CardSideBar />
      <div
        className={cn(
          `w-340px absolute z-200 h-full translate-x-[340px] transition-all ease-in-out`,
          isOpen ? 'translate-x-0' : ''
        )}
      >
        <div className="h-full overflow-y-auto">
          {persistedItemId ? <SelectedItem itemId={persistedItemId} /> : null}
        </div>
      </div>
    </>
  );
}
